import Vue from 'vue'
import store from '@/bootstrap/store'
import vuetify from '@/plugins/vuetify';
import router from '@/bootstrap/router';
import GtrPortalApplication from '@/bootstrap/application/application.vue'
import '@/assets/styles/common.css'
import '@stripe/stripe-js';

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
    router,
    store,
    vuetify,
    render: h => h(GtrPortalApplication)
}).$mount('#app')
